import React, {useEffect, useState} from 'react';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Amplify} from 'aws-amplify';
import awsconfig from './aws-exports';
import Footer from './components/Footer';
import EmailSubscribe from './components/EmailSubscribe';

Amplify.configure(awsconfig);

const backgroundImages = [
    './backgrounds/foxesCastle.jpg',
    './backgrounds/lawsonVilla.jpg',
    './backgrounds/mainCastle.jpg'    
];

const shuffleArray = (array: any) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
};

const App = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        shuffleArray(backgroundImages);

        const changeImage = () => {
            setCurrentImageIndex(prevIndex => (prevIndex + 1) % backgroundImages.length);
        };

        const interval = setInterval(changeImage, 40000); // Change every 40 seconds

        return () => clearInterval(interval);

    }, []);

    // Preload next image whenever current image changes
    useEffect(() => {
        const nextIndex = (currentImageIndex + 1) % backgroundImages.length;
        const img = new Image();
        img.src = backgroundImages[nextIndex];
    }, [currentImageIndex]);

    return (
        <main
            className="relative w-screen h-screen overflow-hidden bg-cover bg-center bg-no-repeat transition-[background-image] duration-1000 ease-in-out"
            style={{backgroundImage: `url(${backgroundImages[currentImageIndex]})`}}
        >
            {/* Signup Container */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center w-full px-5 z-[2] max-h-[600px]:top-[40%]">
                <h1
                    className="font-['Chicle'] text-5xl xl:text-4xl md:text-3xl sm:text-[1.75rem] mb-4 text-white"
                    style={{
                        textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 2px 2px 4px rgba(0,0,0,0.5)'
                    }}
                >
                    Welcome to Tales and Legends!
                </h1>
                <p
                    className="font-['Chicle'] text-2xl xl:text-xl md:text-base sm:text-sm mb-4 text-white"
                    style={{
                        textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 2px 2px 4px rgba(0,0,0,0.5)'
                    }}
                >
                    Enter your email to join the fun.
                </p>
            </div>

            {/* Signup Bar */}
            <div className="absolute bottom-[15%] left-0 right-0 bg-transparent md:bg-white/[0.96] py-5 z-[2] max-h-[600px]:bottom-[10%] max-[480px]:py-[15px]">
                <div className="flex items-center justify-center max-w-3xl mx-auto relative px-5 max-md:flex-col max-md:items-center max-md:px-5 max-lg:pl-[60px]">
                    {/* Profile Picture */}
                    <div
                        className="w-20 h-20 mb-5 static transform-none md:w-[120px] md:h-[120px] md:mb-0 md:absolute md:-left-[140px] md:top-1/2 md:-translate-y-1/2 xl:w-[100px] xl:h-[100px] xl:-left-[120px] lg:left-0 lg:-translate-x-1/2 rounded-full overflow-hidden"
                        style={{
                            boxShadow: '0 0 0 4px #fff, 0 0 0 6px rgba(0,0,0,0.1), 0 0 0 10px #fff, 0 0 0 12px rgba(0,0,0,0.1)'
                        }}
                    >
                        <img src="./favico/favicon-512.png" alt="Play My Fate Logo" className="w-full h-full object-cover"/>
                    </div>

                    {/* Signup Form */}
                    <EmailSubscribe variant="inline" />
                </div>
            </div>

            {/* Footer */}
            <div className="absolute bottom-0 left-0 right-0 z-[3]">
                <Footer />
            </div>

            <ToastContainer/>
        </main>
    );
};

export default App;


